import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Slide from '@mui/material/Slide';
import PurpleButton from '../common/buttonTheme';
import useDrawerHistory from '../hooks/useDrawerHistory';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CompletionNoteDialog({ open, onSkip, onAddNote }) {
  const [noteText, setNoteText] = React.useState("");

  // Manage browser history for back button behavior
  useDrawerHistory(open, onSkip, 'completion-note-dialog');

  const handleAddNote = () => {
    onAddNote(noteText);
    setNoteText("");
  };

  const handleSkip = () => {
    setNoteText("");
    onSkip();
  };

  const handleClose = () => {
    setNoteText("");
    onSkip();
  };

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="completion-note-dialog-description"
    >
      <DialogTitle>Add a Completion Note?</DialogTitle>
      <DialogContent>
        <DialogContentText id="completion-note-dialog-description">
          Would you like to add a note about completing this task?
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="completion-note"
          label="Completion Note"
          fullWidth
          multiline
          rows={3}
          variant="standard"
          value={noteText}
          onChange={(e) => setNoteText(e.target.value)}
          placeholder="What did you accomplish? Any key learnings?"
        />
      </DialogContent>
      <DialogActions>
        <PurpleButton variant="contained" onClick={handleSkip}>Skip</PurpleButton>
        <PurpleButton variant="contained" onClick={handleAddNote}>Add Note</PurpleButton>
      </DialogActions>
    </Dialog>
  );
}
